// extracted by mini-css-extract-plugin
export default {"p__card":"Card_p__card__TcpXL","p__rVieBtn":"Card_p__rVieBtn__IUK-U","p__detail":"Card_p__detail__Ldpy6","p__rVieInfo":"Card_p__rVieInfo__SCZ+E"};